import {BrandService} from '../services/brand.service';

export class DigitalDataAdobeTM {
    page: Page;

    constructor(withConstData = false, models = null) {
        this.page = new Page();

        if (withConstData) {
            this.page.pageInfo.vehicleBrand = BrandService.getCurrentBrand().slug;
            this.page.pageInfo.language = 'pl';
            this.page.pageInfo.countryCode = 'pl';
            this.page.pageInfo.businessArea = 'sales';
            this.page.pageInfo.vehicleCategory = BrandService.getCurrentBrand().code === '77' ? 'lcv' : 'pc';
            this.page.pageInfo.pageName = BrandService.getCurrentBrand().slug + ':pl:shopping-tools:used';
            this.page.category.primaryCategory = BrandService.getCurrentBrand().slug + ':pl:shopping-tools:used';
            this.page.category.subCategory1 = BrandService.getCurrentBrand().slug + ':pl:shopping-tools';
            this.page.category.subCategory2 = BrandService.getCurrentBrand().slug + ':pl:shopping-tools:used';
            this.page.category.pageType = BrandService.getCurrentBrand().slug + ':pl:shopping-tools';

            if (models) {
              models = models.replace('avenger-elektryczny', 'avenger-bev')
                .replace('avenger-ice', 'avenger');
              const modelsArray = models.split(':;');
              if (modelsArray.length > 1) {
                this.page.pageInfo.rangeModels = modelsArray.join('|');
              } else {
                this.page.pageInfo.vehicleModel = modelsArray.join('|');
                this.page.pageInfo.vehicleModelName = modelsArray.join('|');
              }
            }
        }
    }
}

export class Page {
    pageInfo: PageInfo;
    category: Category;
    component: Component;

    constructor() {
        this.pageInfo = new PageInfo();
        this.category = new Category();
        this.component = new Component();
    }
}

export class PageInfo {
    vehicleTrim: string;
    vehicleModel: string;
    vehicleModelName: string;
    vehicleBrand: string;
    vehicleID: string;
    language: string;
    countryCode: string;
    pageName: string;
    rangeModels: string;
    vehicleCategory: string;
    vehicleEngine: string;
    mktgCampaignID: string;
    businessArea: string;

    constructor() {
      this.vehicleTrim = '';
      this.vehicleModel = '';
      this.vehicleModelName = '';
      this.vehicleBrand = '';
      this.vehicleID = '';
      this.rangeModels = '';
      this.vehicleCategory = '';
      this.vehicleEngine = '';
    }
}

export class Category {
    primaryCategory: string;
    subCategory1: string;
    subCategory2: string;
    pageType: string;
}

export class Component {
    inventorySearch: InventorySearch;
    form: Form;
    paymentCalc: PaymentCalc;
    configurator: Configurator;

    constructor() {
        this.inventorySearch = new InventorySearch();
        this.form = new Form();
        this.paymentCalc = new PaymentCalc();
        this.configurator = new Configurator();
    }
}

export class Configurator {
    stepName: string;

    constructor() {
        this.stepName = '';
    }
}

export class InventorySearch {
    filterList: any;
    numberOfVehicles: number;
}

export class Form {
    stepName: string;
    nameType: string;
    leadType: string;
    transactionID: string;
}

export class PaymentCalc {
    term: number;
    downPayment: number;
    purchaseType: string;
    tradeIn: number;
}
